import { Component, Inject, Vue, Watch } from 'vue-property-decorator';

import template from './tmpl.vue';

@Component({
    components: {},
    mixins: [template],
})
class C extends Vue {
    @Inject('reload')
    readonly reload!: Function;

    detailActive = '';
    details = {};
    isFold: boolean = false;
    isFoldDetails: boolean = false;
    isLevelSmall: boolean = false;
    navLink: any = [];
    navName: string = 'shipments-4-shippers';

    @Watch('isFold')
    watchIsFold(to: any, from: any) {
        this.$emit('onSidebar', this.isFold);
    }

    @Watch('$route')
    routechange(to: any, from: any) {
        this.routerNav(to.name, false);
    }

    mounted() {
        this.navLink = [
            {
                title: 'Shipments',
                to: '/shipments-4-shippers',
                icon: require('@/assets/images/navbar/ship.svg'),
            },
        ];

        const routerNamre = this.$route.name;
        this.routerNav(routerNamre);

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.setAttribute('class', 'getting-started-up-js');
        script.appendChild(
            document.createTextNode(
                ` function hideGettingbox() {  var node = document.querySelector(".getting-started-box"); if (node && node.parentNode) { node.style.display = "none"; } };function showGettingbox() {  var node = document.querySelector(".getting-started-box"); if (node && node.parentNode) { node.style.display = "block"; } };`
            )
        );
        document.body.appendChild(script);
    }

    foldDetails(isFoldDetails: boolean, item: any, foldDetails: boolean = true) {
        this.navName = item.title;
        this.details = { title: item.title, child: item.child };
        if (item.child) {
            if (!isFoldDetails) this.isFoldDetails = true;
            this.isFold = false;
            this.isLevelSmall = true;
        } else {
            this.isLevelSmall = false;
            this.isFoldDetails = false;
            if (foldDetails) {
                this.$router.push(item.to);
            }
        }
        this.detailActive = '';
        if (this.$route.name == 'trackShipmentLoggedIn') {
            this.reload();
        }
    }

    routerNav(routerNamre: any, isGotoRouter: boolean = true) {
        switch (routerNamre) {
            case 'shipment':
                this.foldDetails(true, this.navLink[0], isGotoRouter);
                this.isFold = false;
                this.isFoldDetails = true;
                this.navName = this.navLink[2].title;
                this.detailActive = 'Shipments';
                break;
            default:
                break;
        }
    }

    toggle() {
        if (this.isFoldDetails) {
            this.isLevelSmall = true;
        }
        this.isFold = !this.isFold;
    }
}

export default C;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/shipments-4-shippers-details/components/sidebar/index.ts